import React from 'react';
import { NavLink } from 'react-router-dom';
import { LayoutDashboard, Image, User, LogOut, Users } from 'lucide-react';

const Sidebar = ({ role = 'creator' }) => {

    const handleLogout = () => {
        localStorage.removeItem('paradise_user');
        localStorage.removeItem('paradise_token');
        window.location.href = '/';
    };

    return (
        <div className="w-64 bg-white h-screen border-r border-gray-200 flex flex-col fixed left-0 top-0">
            <div className="p-6 border-b border-gray-100">
                <h1 className="text-xl font-bold uppercase tracking-widest font-mono">PARADISE</h1>
                <span className="text-xs text-gray-400 uppercase tracking-wide">{role} PORTAL</span>
            </div>

            <nav className="flex-1 p-4 space-y-2">
                {role === 'creator' && (
                    <>
                        <NavLink
                            to="/creator"
                            end
                            className={({ isActive }) =>
                                `flex items-center space-x-3 px-4 py-3 rounded-md transition-colors ${isActive ? 'bg-black text-white' : 'text-gray-600 hover:bg-gray-50'}`
                            }
                        >
                            <LayoutDashboard size={18} />
                            <span className="text-sm font-medium uppercase tracking-wide">Overview</span>
                        </NavLink>
                        <NavLink
                            to="/creator/sets"
                            className={({ isActive }) =>
                                `flex items-center space-x-3 px-4 py-3 rounded-md transition-colors ${isActive ? 'bg-black text-white' : 'text-gray-600 hover:bg-gray-50'}`
                            }
                        >
                            <Image size={18} />
                            <span className="text-sm font-medium uppercase tracking-wide">My Sets</span>
                        </NavLink>
                        <NavLink
                            to="/creator/profile"
                            className={({ isActive }) =>
                                `flex items-center space-x-3 px-4 py-3 rounded-md transition-colors ${isActive ? 'bg-black text-white' : 'text-gray-600 hover:bg-gray-50'}`
                            }
                        >
                            <User size={18} />
                            <span className="text-sm font-medium uppercase tracking-wide">Profile</span>
                        </NavLink>
                    </>
                )}

                {role === 'admin' && (
                    <>
                        {/* Admin Links */}
                        <NavLink
                            to="/admin"
                            end
                            className={({ isActive }) =>
                                `flex items-center space-x-3 px-4 py-3 rounded-md transition-colors ${isActive ? 'bg-black text-white' : 'text-gray-600 hover:bg-gray-50'}`
                            }
                        >
                            <LayoutDashboard size={18} />
                            <span className="text-sm font-medium uppercase tracking-wide">Dashboard</span>
                        </NavLink>
                        <NavLink
                            to="/admin/sets"
                            className={({ isActive }) =>
                                `flex items-center space-x-3 px-4 py-3 rounded-md transition-colors ${isActive ? 'bg-black text-white' : 'text-gray-600 hover:bg-gray-50'}`
                            }
                        >
                            <Image size={18} />
                            <span className="text-sm font-medium uppercase tracking-wide">Review Sets</span>
                        </NavLink>
                        <NavLink
                            to="/admin/creators"
                            className={({ isActive }) =>
                                `flex items-center space-x-3 px-4 py-3 rounded-md transition-colors ${isActive ? 'bg-black text-white' : 'text-gray-600 hover:bg-gray-50'}`
                            }
                        >
                            <Users size={18} />
                            <span className="text-sm font-medium uppercase tracking-wide">Manage Creators</span>
                        </NavLink>
                    </>
                )}
            </nav>

            <div className="p-4 border-t border-gray-100">
                <button
                    onClick={handleLogout}
                    className="flex items-center space-x-3 px-4 py-3 w-full text-left text-red-500 hover:bg-red-50 rounded-md transition-colors"
                >
                    <LogOut size={18} />
                    <span className="text-sm font-medium uppercase tracking-wide">Log Out</span>
                </button>
            </div>
        </div>
    );
};

export default Sidebar;
